import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { Table } from '../../Table/Table.es.js';
import { useTableContext } from '../../Table/Table.Context/index.es.js';

const LoadingRows = ({ getState, getVisibleFlatColumns })=>{
    const [, { setNumLoadingColumns }] = useTableContext();
    const { pagination: { pageSize } } = getState();
    useEffect(()=>{
        setNumLoadingColumns(getVisibleFlatColumns().length);
    }, [
        getVisibleFlatColumns,
        setNumLoadingColumns
    ]);
    return jsx(Table.Body, {
        children: jsx(Table.Body.Loader, {
            numRows: pageSize
        })
    });
};

export { LoadingRows };
//# sourceMappingURL=LoadingRows.es.js.map
